// extracted by css-extract-rspack-plugin
export default {"selectedStatus":"IssueStatusPicker-module__selectedStatus__tVohu"};